import { memo } from "react";
import { TeamLogo } from "../../../../components/shared/team-logo";
import { useSimilarPitchers } from "../../hooks/use-similar-pitchers";

export const SimilarPitchers = memo(({ playerId, year, division }) => {
  const { similarPlayers, isLoading, player, note, error } = useSimilarPitchers({
    playerId,
    year,
    division,
  });

  if (isLoading) return <div className="text-center py-4" />;
  if (error) return null;
  if (!similarPlayers.length) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mt-8">
      <div className="mb-3">
        <h3 className="text-sm font-semibold text-gray-800 mb-1">Similar Pitchers to {player}</h3>
        {note && <p className="text-xs text-gray-500">{note}</p>}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {similarPlayers.slice(0, 5).map((p) => (
          <a
            key={`${p.player_id}-${p.year}`}
            href={`/player/${p.player_id}`}
            className="flex items-center p-2 hover:bg-blue-50 rounded-lg transition-colors"
          >
            <div className="h-8 w-8 flex-shrink-0 mr-2 bg-gray-100 rounded-full overflow-hidden">
              <TeamLogo teamId={p.team_id} teamName={p.team_name} />
            </div>
            <span className="text-xs truncate">
              {p.year} - {p.player_name}
            </span>
          </a>
        ))}
      </div>
    </div>
  );
});

SimilarPitchers.displayName = "SimilarPitchers";
